import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  maskPhoneNumber,
  LoadingGrid,
  formatDateMonth,
  formatPriceMejorado,
} from '../../../../../_mexablock/helpers';
import { TopUpBalanceModal } from '../../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { NewActivationModal } from '../_modals/NewActivation';
import { NewActivationMiFiModal } from '../_modals/NewActivationMiFi';
import { NewActivationHogarModal } from '../_modals/NewActivationHogar';
import { MultipleModal } from '../_modals/MultipleModal';
import { useGetAll } from '../hooks/ActivacionHook';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { Filter } from '../../../pagos/pagados/components/Filter';

const View: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual,
  ) as UserModel;
  const { saldo } = user;
  const [loadingView, setloadingView] = useState(true);
  const [idRow, setIdRow] = useState(0);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [visivilityMiFiModal, setVisivilityMiFiModal] = useState(false);
  const [visivilityHogarModal, setVisivilityHogarModal] = useState(false);
  const [multipleModal, setMultipleModal] = useState(false);
  const [visivilityRechargeModal, setVisivilityRechargeModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [dateState, setDateState] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    search: '',
  });

  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  // Disparar recarga cuando cambien los filtros
  useEffect(() => {
    if (initFilterValues.init_date || initFilterValues.end_date || initFilterValues.search) {
      setReloadGrid(Math.random() * 40);
    }
  }, [initFilterValues.init_date, initFilterValues.end_date, initFilterValues.search]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const normalActivation = () => {
    setTitleModal('Activación');
    setVisivilityModal(!visivilityModal);
  };

  const mifiActivation = () => {
    setVisivilityMiFiModal(!visivilityMiFiModal);
  };

  const hogarActivation = () => {
    setVisivilityHogarModal(!visivilityHogarModal);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/;

    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
      setInitFilterValues((prev) => ({ ...prev, search: inputValue }));
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: values.init_date,
      end_date: values.end_date,
    }));
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      search: '',
    });
    setDateState([]);
    setInputValue('');
    setSearchFilter('');
    setReloadGrid(Math.random() * 40); // Forzar recarga al limpiar
  };

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => row.createdAt,
      cell: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },
    {
      id: 'source',
      name: <div className="fw-bolder text-muted me-5">Canal</div>,
      selector: (row: any) => row.source,
      sortable: true,
    },
    {
      id: 'product',
      name: <div className="fw-bolder text-muted me-5">Producto</div>,
      selector: (row: any) => {
        if (
          row?.offer?.service_type === 'HO' ||
          row?.product_type === 'hogar' ||
          row?.product_type === 'HOGAR' ||
          row?.product_type === 'HO' ||
          row?.offer?.type_id === 50
        ) {
          return (
            <span
              className="badge fw-bolder"
              style={{ color: '#0a8a5c', backgroundColor: '#e4f7ee' }}
            >
              Internet Hogar
            </span>
          );
        }
        if (
          row?.offer?.service_type === 'MIFI' ||
          row?.offer?.type_id === 49 ||
          row?.product_type === 'MIFI' ||
          row?.product_type === 'mifi'
        ) {
          return <span className="badge badge-light-info fw-bolder">MiFi</span>;
        }
        return <span className="badge badge-light-primary fw-bolder">Telefonía</span>;
      },
      sortable: true,
      width: '150px',
    },
    {
      id: 'identifier_value',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row.identifier_value,
      sortable: true,
      width: '200px',
    },
    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => {
        const first = row?.customer?.first_name ?? '';
        const last = row?.customer?.father_last_name ?? '';
        const fullName = `${first} ${last}`.trim();

        return fullName || 'Sin nombre';
      },
      sortable: true,
    },
    {
      id: 'amount',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) => formatPriceMejorado(row.amount, 'es-MX', 'MXN'),
      sortable: true,
    },
    {
      id: 'userCreate',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        row.source === 'Web'
          ? `${row.userCreate.first_name} ${row.userCreate.father_last_name}`
          : 'Usuario App',
      sortable: true,
    },
  ];

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="d-flex align-items-center gap-4">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
                <div className="d-flex align-items-center position-relative me-4">
                  <span
                    className="position-absolute ms-3"
                    style={{ zIndex: 10 }}
                  >
                    <i className="bi bi-search fs-4 text-muted"></i>
                  </span>

                  <input
                    type="text"
                    className="form-control form-control-solid ps-9"
                    placeholder="ICCID"
                    maxLength={19}
                    value={inputValue}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  data-kt-menu="true"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-white me-1"
                  />
                  Nueva Activación
                </a>
                <div
                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                  data-kt-menu="true"
                >
                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      href="#/"
                      onClick={normalActivation}
                    >
                      Telefonía
                    </a>
                  </div>
                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      href="#/"
                      onClick={mifiActivation}
                    >
                      MiFi
                    </a>
                  </div>
                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      href="#/"
                      onClick={hogarActivation}
                    >
                      Internet Hogar
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {loadingView ? (
              <LoadingGrid text="Cargando..." />
            ) : (
              <TableList data={data} columns={columns} />
            )}
          </div>
        </div>
      </div>
      <NewActivationModal
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            // setLoadingGrid(true);
            setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setVisivilityModal(!visivilityModal);
        }}
      />
      <NewActivationMiFiModal
        show={visivilityMiFiModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setVisivilityMiFiModal(!visivilityMiFiModal);
        }}
      />
      <NewActivationHogarModal
        show={visivilityHogarModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setVisivilityHogarModal(!visivilityHogarModal);
        }}
      />
      <TopUpBalanceModal
        show={visivilityRechargeModal}
        handleClose={(updateData: boolean) => {
          setVisivilityRechargeModal(!visivilityRechargeModal);
        }}
      />
      <MultipleModal
        id_row={idRow}
        title={titleModal}
        show={multipleModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            // setLoadingGrid(true);
            // setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setMultipleModal(!multipleModal);
        }}
      />
    </>
  );
};

export { View };
